import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './question.css'
import Stack from 'react-bootstrap/Stack';


const Question = ({ handleQuestionClick }) => {
    return (
        <>
            <div className='main'>
                <h1 className=' mb-4'>City parking made easy by <span>Dencity</span></h1>
                <h5 className='mb-5'>Explore our services in below cities now:</h5>
                <Stack className='stack mt-4' gap={5} >
                    <div className='rectangular ' onClick={(e) => { handleQuestionClick("newyork") }} >New York</div>
                    <div className='rectangular paris' onClick={(e) => { handleQuestionClick("paris") }} >Paris</div>
                    {/* <div className='rectangular' onClick={(e) => { handleQuestionClick("bordeaux") }} >Bordeaux</div> */}
                </Stack>
                <footer className='footer'></footer>
            </div>
        </>
    );
}

export default Question;